__webpack_require__.p = "//yastatic.net/s3/ai-platform/frontend/_/";